import { useNavigate } from "react-router-dom";
import "./style.sass";
import { useHandler } from "./handler";
import assets from "../../assets";
import { ROUTE_TEST_MANAGEMENT } from "../../route/teacherRoute";

export const AdminLeaderboard = ({
  roomCode,
  resetQuizFlow,
  setShowHistory,
  leaderboard,
  isLiveMode = false,
}) => {
  const navigate = useNavigate();
  const { finalScores } = useHandler({ roomCode });
  // const leaderboardData = isLiveMode
  //   ? leaderboard || []
  //   : finalScores?.leaderboard || [];
  const leaderboardData = finalScores?.leaderboard || [];
  const topPlayers = leaderboardData
    .filter((p) => p.rank <= 3)
    .map((p) => ({
      ...p,
      color: p.rank === 1 ? "#60A5FA" : p.rank === 2 ? "#A78BFA" : "#F59E0B",
      background:
        p.rank === 1 ? "rgba(56, 189, 248, 0.25)" : p.rank === 2 ? "rgba(139, 92, 246, 0.30)" : "rgba(251, 146, 60, 0.25)",
      border:
        p.rank === 1 ? "1px solid rgba(56, 189, 248, 0.25)" : p.rank === 2 ? "rgba(139, 92, 246, 0.30)" : "rgba(251, 146, 60, 0.25)",
      
    }));

  return (
    <section className="leaderboard-page">
      <h2>
        Final <span className="scores">Scores</span>
      </h2>
      <p className="subtitle-per">
        Incredible performance! Here are the final results.
      </p>

      {/* TOP 3 */}
      <section className="top-players">
        {topPlayers.map((p, i) => (
          <section key={i} className={`player-card rank-${p.rank}`} style={{ background: p.background, border:p.border }}>
            <section className="async-avatar" style={{ background: p.color }}>
              <h5 className="nick-name">{p?.nickname?.charAt(0) || "?"}</h5>
              <section className="player-rank" style={{ background: p.color }}>
                <h6>{p.rank} </h6>
              </section>
            </section>
            <section className="nick-score-card">
            <h4 className="nickname">{p.nickname}</h4>
            <span>{p.score}</span></section>
          </section>
        ))}
      </section>

      {/* TABLE */}
      <section className="leaderboard-list">
        <section className="header">
          <span>Rank</span>
          <span>Player</span>
          <span>Score</span>
        </section>

        {leaderboardData.map((p, i) => (
          <section key={i} className={`row ${p.you ? "you" : ""}`}>
            <span>{p?.rank ?? "-"}</span>
            <span>{p?.nickname || "-"}</span>
            <span>{p?.score ?? 0}</span>
          </section>
        ))}
      </section>

      {/* ACTIONS */}
      <section className="actions-next">
        <button
          className="back-test-btn"
          onClick={() => navigate(ROUTE_TEST_MANAGEMENT)}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Back to Test Management
        </button>

        <button className="primary-new-btn" onClick={resetQuizFlow}>
          + New Room
        </button>
      </section>
    </section>
  );
};
